import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'speedKbToMb'
})
export class SpeedKbToMbPipe implements PipeTransform {

  transform(value: number): string {
    if (isNaN(value) || !isFinite(value)) {
      return 'N/A';
    }

    // If the value is greater than or equal to 1024 KB (1 MB)
    if (value >= 1024) {
      // Convert KB to MB
      const mbValue = value / 1024;
      return mbValue.toFixed(0) + ' Mbps';
    } else {
      // If the value is less than 1024 KB, return it in KB
      return value.toFixed(0) + ' Kbps';
    }
  }

}
